import { TableCell, TableHead } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

import { ReactComponent as FilterIcon } from '../../../../assets/images/blueTheme/filter.svg';
import { HeaderIconBasedStyles, stickyColumn } from '../styled';

export const StyledHeaderCell = styled.span`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const StyledTableHeader = styled(TableHead)(
  ({ theme: { admanColors, spacers, colors } }) => css`
    background-color: ${admanColors!.gray.light.bg0[0]};

    tr {
      border-bottom: 1px solid ${admanColors!.gray.light.bg3[2]};

      &:first-child {
        border-top: 1px solid ${admanColors!.gray.light.bg3[2]};

        th {
          span {
            justify-content: center;
          }

          &:not(:last-child) {
            box-shadow: inset -1px 0 2px -1px ${admanColors!.gray.light.bg3[2]};
          }
        }
      }
    }

    th {
      height: inherit;
      padding: ${spacers!.spacer02};
      color: ${admanColors!.gray.light.fg1[0]};
      text-transform: capitalize;
      cursor: default !important;
      background-color: ${colors!.colorWhite};

      span {
        font-family: InspireTWDC;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        font-weight: 400;
      }

      &.leftBorder {
        box-shadow: inset 1px 0 2px -1px ${admanColors!.gray.light.bg3[2]};
      }

      &.rightBorder {
        box-shadow: inset -1px 0 2px -1px ${admanColors!.gray.light.bg3[2]};
      }
    }
  `
);

export const StyledTableCell = styled(TableCell)<{ $minWidth?: number; $left?: number }>(
  ({ $minWidth, $left }) => css`
    min-width: ${`${$minWidth || 20}px`};

    &.sticky {
      z-index: 1;
      ${stickyColumn};

      left: ${$left ? `${$left}px` : 0};
    }
  `
);

export const StyledFilterArrow = styled(FilterIcon)`
  ${HeaderIconBasedStyles}
`;
